import React, { useEffect, useRef } from "react";
import { BASE_URL, DOMAIN } from "./../../global";
import { Link } from "react-router-dom";
import moment from "moment";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import PrintIcon from "@mui/icons-material/Print";
import { ToastContainer, toast } from "react-toastify";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import LastPageIcon from "@mui/icons-material/LastPage";
import IconButton from "@mui/material/IconButton";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { useTheme } from "@mui/material/styles";

import {
  Button,
  TableContainer,
  Toolbar,
  TextField,
  Autocomplete,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Modal,
  Box,
  Typography,
  TablePagination,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  ButtonGroup,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import ExcelDownload from "../../utils/components/excelDownload";
import html2pdf from "html2pdf.js";
import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";
import { Table } from "react-bootstrap";
import { showComponent } from "../helper/helpers";

var form11Columns = [
  {
    id: "id",
    label: "Sr. No.",
    align: "left",
    minWidth: 40,
  },
  // {
  //   id: "equipment_name",
  //   label: "Name of Equipment",
  //   align: "left",
  //   minWidth: 40,
  // },
  {
    id: "typeIdentificationNumber",
    label: "Name of Equipment / Plant",
    align: "left",
    minWidth: 40,
  },
  {
    id: "capacity",
    label: "Safe Working Load",
    align: "left",
    minWidth: 40,
  },
  {
    id: "dateOfExamination",
    label: "Last Examined by Whom & Date",
    align: "left",
    minWidth: 40,
  },
  {
    id: "inspectionDate",
    label: "Date of Testing",
    align: "left",
    minWidth: 40,
  },
  {
    id: "certificateValidity",
    label: "Next due Date of Testing",
    align: "left",
    minWidth: 40,
  },
];

var form13Columns = [
  {
    id: "id",
    label: "Sr. No.",
    align: "left",
    minWidth: 40,
  },
  // {
  //   id: "equipment_name",
  //   label: "Name of Equipment",
  //   align: "left",
  //   minWidth: 40,
  // },
  {
    id: "distinctiveNumber",
    label: "Name of Equipment / Plant",
    align: "left",
    minWidth: 40,
  },
  {
    id: "recommendedAfterExamination",
    label: "Safe Working Load",
    align: "left",
    minWidth: 40,
  },
  {
    id: "utrasonicTestDate",
    label: "Ultrasonic Examination Date of Testing",
    align: "left",
    minWidth: 40,
  },
  {
    id: "utrasonicNextDueDate",
    label: "Ultrasonic Next Due Date of Testing",
    align: "left",
    minWidth: 40,
  },
  {
    id: "internalTestDate",
    label: "Internal Examination Date of Testing",
    align: "left",
    minWidth: 40,
  },
  {
    id: "internalExaminationDueDate",
    label: "Internal Next Due Date of Testing",
    align: "left",
    minWidth: 40,
  },
  {
    id: "hydraulicTestDate",
    label: "Hydraulic Examination Date of Testing",
    align: "left",
    minWidth: 40,
  },
  {
    id: "hydraulicNextDueDate",
    label: "Hydraulic Next Due Date of Testing",
    align: "left",
    minWidth: 40,
  },
];

const notNeededColumn = ["id"];

const SummaryList = (props) => {
  const printComponentRef = React.useRef();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [searchBy, setSearchBy] = React.useState("");
  const [searchKey, setSearchKey] = React.useState("");
  const [totalRows, setTotalRows] = React.useState(0);
  const _clientId = localStorage.getItem("clientId");
  const _userType = localStorage.getItem("type");
  const [from, setFrom] = React.useState(null);
  const [to, setTo] = React.useState(null);
  const [finalData, setFinalData] = React.useState([]);
  const [downloadPdfloading, setDownlaodPdfLoading] = React.useState(false);
  const [templateList, setTemplateList] = React.useState([]);
  const [factoryList, setFactoryList] = React.useState([]);
  const [shopsList, setShopsList] = React.useState([]);
  const [selectedIds, setSelectedIds] = React.useState({
    templateId: null,
    factoryId: null,
    shopId: null,
  });
  let columns = selectedIds?.templateId == 12 ? form13Columns : form11Columns;
  console.log("selectedIds", selectedIds);

  console.log("data", finalData);

  const getQuery = (count) => {
    let whereConditions = "";
    let pagination_settings = "";

    // if (_userType == 3)
    //   whereConditions +=
    //     whereConditions.length > 0
    //       ? `and cert.clientId = ${_clientId}`
    //       : `and cert.clientId = ${_clientId}`;
    // whereConditions +=
    //   whereConditions.length > 0
    //     ? " AND cert.status = 1"
    //     : "AND cert.status = 1";

    if (selectedIds?.templateId) {
      console.log("selectedIds?.templateId", selectedIds?.templateId);
      whereConditions += ` WHERE reportValues.templateId = ${selectedIds?.templateId} `;
    }

    if (selectedIds?.factoryId) {
      let colName =
        "REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.factoryId'), '\"', '')";
      whereConditions += ` AND ${colName} = ${selectedIds?.factoryId} `;
    }

    if (selectedIds?.shopId) {
      let colName =
        "REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.shopId'), '\"', '')";
      whereConditions += ` AND ${colName} = ${selectedIds?.templateId} `;
    }

    if (rowsPerPage != -1) {
      pagination_settings = `limit ${rowsPerPage} offset ${
        rowsPerPage * Number(page)
      }`;
    }

    let data = {
      query: `SELECT reportValues.templateId, reportValues.id, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.reportNumber'), '\"', ''), '') AS reportNumber, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.certificateValidity'), '\"', ''), '') AS certificateValidity, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.shopId'), '\"', ''), '') AS shopId, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.reportDate'), '\"', ''), '') AS reportDate, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.equipmentId'), '\"', ''), '') AS equipmentId, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.typeIdentificationNumber'), '\"', ''), '') AS typeIdentificationNumber,IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.distinctiveNumber'), '\"', ''), '') AS distinctiveNumber, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.capacity'), '\"', ''), '') AS capacity, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.dateOfExamination'), '\"', ''), '') AS dateOfExamination, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.inspectionDate'), '\"', ''), '') AS inspectionDate, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.recommendedAfterExamination'), '\"', ''), '') AS recommendedAfterExamination, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.utrasonicTestDate'), '\"', ''), '') AS utrasonicTestDate, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.hydraulicTestDate'), '\"', ''), '') AS hydraulicTestDate, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.internalTestDate'), '\"', ''), '') AS internalTestDate, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.internalExaminationDueDate'), '\"', ''), '') AS internalExaminationDueDate, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.certificateValidityDate'), '\"', ''), '') AS certificateValidityDate, templates.name, clients.name AS client_name, addresses.address AS client_address, clients.emailId AS client_email, shops.name AS shop_name, products.name AS equipment_name FROM reportValues LEFT JOIN templates ON reportValues.templateId = templates.id LEFT JOIN clients ON JSON_EXTRACT(reportValues.templateValues, '$.factoryId') = clients.id LEFT JOIN addresses ON addresses.id = SUBSTRING_INDEX(clients.address, ',', 1) LEFT JOIN shops ON REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.shopId'), '\"', '') = shops.id LEFT JOIN products ON REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.equipmentId'), '\"', '') = products.id ${whereConditions} ORDER BY id DESC ${pagination_settings}`,
    };

    if (count)
      data.query = `SELECT COUNT(*) AS no_of_rows FROM reportValues LEFT JOIN templates ON reportValues.templateId = templates.id ${whereConditions}`;
    return data;
  };

  // api calls
  function getTotalRows() {
    let data = getQuery(true);

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0]?.no_of_rows);
      })
      .catch((err) => {
        console.log("datasheet data fetching error: ", err);
      });
  }

  function fetchFinalData() {
    let data = getQuery();

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setFinalData(res.data);
      })
      .catch((err) => {
        console.log("  error: ", err);
      });
  }

  const search = () => {
    fetchFinalData();
  };

  const generatePDF = async () => {
    setDownlaodPdfLoading(true);
    try {
      const element = printComponentRef.current;
      let pdf = await html2pdf()
        .from(element)
        .set({
          margin: [10, 1, 20, 1],
          filename: `masterInOut.pdf`,
          pagebreak: { after: "section", mode: ["css", "legacy"] },
          html2canvas: {
            dpi: 192,
            scale: 3,
            letterRendering: true,
            useCORS: true,
          },
          image: { type: 'png', quality: 0.4 },
          jsPDF: {
            orientation: "portrait",
            unit: "pt",
            format: "a4",
            compress: true,
          },
        })
        .toPdf()
        .get("pdf");

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(0, 0, 0);
        pdf.setFont("helvetica", "bold");

        // const text = "SUMMARY REPORT";
        // const pageWidth = pdf.internal.pageSize.getWidth();
        // const textWidth =
        //   (pdf.getStringUnitWidth(text) * 12) / pdf.internal.scaleFactor;
        // const x = (pageWidth - textWidth) / 2;
        // pdf.setFontSize(12);
        // pdf.text(text, x, 20);
      }

      const blob = pdf.output("blob");
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `summaryReport.pdf`;
      a.click();

      setDownlaodPdfLoading(false);
    } catch (error) {
      console.error("Error generating PDF:", error);
      setDownlaodPdfLoading(false);
    }
  };

  const getAllTemplate = () => {
    axiosWithToken
      .get(BASE_URL + `templates`)
      .then((res) => {
        setTemplateList(res.data);
      })
      .catch((err) => {
        console.log(" error: ", err);
      });
  };

  const getAllFactory = () => {
    axiosWithToken
      .get(BASE_URL + `clients`)
      .then((res) => {
        setFactoryList(res.data);
      })
      .catch((err) => {
        console.log(" error: ", err);
      });
  };

  const getAllShops = () => {
    axiosWithToken
      .get(BASE_URL + `shops`)
      .then((res) => {
        setShopsList(res.data);
      })
      .catch((err) => {
        console.log(" error: ", err);
      });
  };

  var refresh = () => {
    window.location.reload(false);
  };

  useEffect(() => {
    getTotalRows();
    getAllTemplate();
    getAllFactory();
    getAllShops();
  }, []);

  // useEffect(() => {
  //   fetchFinalData();
  // }, [rowsPerPage, page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  return (
    <div>
      <TableContainer component={Paper} sx={{ mt: 2, p: 2 }}>
        <div
          className="mb-2"
          style={{
            display: "flex",
            float: "left",
            justifyContent: "flex-end",
          }}
        >
          <Autocomplete
            sx={{
              m: 0,
              minWidth: 180,
              marginLeft: "10px",
            }}
            size="small"
            onChange={(event, newValue) => {
              setSelectedIds((prevState) => ({
                ...prevState,
                templateId: newValue ? newValue.id : null,
              }));
            }}
            options={templateList}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField {...params} label="Select Form Type" />
            )}
          />

          <Autocomplete
            sx={{
              m: 0,
              minWidth: 180,
              marginLeft: "10px",
            }}
            size="small"
            onChange={(event, newValue) => {
              setSelectedIds((prevState) => ({
                ...prevState,
                factoryId: newValue ? newValue.id : null,
              }));
            }}
            options={factoryList}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField {...params} label="Select Factory" />
            )}
          />

          <Autocomplete
            sx={{
              m: 0,
              minWidth: 180,
              marginLeft: "10px",
            }}
            size="small"
            onChange={(event, newValue) => {
              setSelectedIds((prevState) => ({
                ...prevState,
                shopId: newValue ? newValue.id : null,
              }));
            }}
            options={shopsList}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField {...params} label="Select Shop" />
            )}
          />

          <div
            style={{ marginLeft: "10px", marginRight: "10px" }}
            id="quotationlist_datefrom"
          >
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              classNames="mr-2"
            >
              <DatePicker
                slotProps={{ textField: { size: "small", fullWidth: true } }}
                label="From"
                value={from ? new Date(from) : ""}
                inputFormat="dd/MM/yyyy"
                format="dd/MM/yyyy"
                onChange={(newValue) => setFrom(newValue)}
                renderInput={(params) => <TextField {...params} size="small" />}
              />
            </LocalizationProvider>
          </div>

          <div style={{ marginRight: "10px" }} id="quotationlist_dateto">
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                slotProps={{ textField: { size: "small", fullWidth: true } }}
                label="To"
                value={to ? new Date(to) : ""}
                inputFormat="dd/MM/yyyy"
                format="dd/MM/yyyy"
                onChange={(newValue) => setTo(newValue)}
                renderInput={(params) => <TextField {...params} size="small" />}
                style={{ marginRight: "20px" }}
              />
            </LocalizationProvider>
          </div>

          <Button
            variant="contained"
            size="small"
            sx={{ m: 0 }}
            style={{ marginLeft: "10px" }}
            onClick={() => {
              search();
            }}
          >
            <SearchIcon />
          </Button>
        </div>

        <div
          className="mb-2"
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
          }}
        >
          <ExcelDownload
            finalData={finalData}
            notNeededColumn={notNeededColumn}
          />
          <Button
            variant="contained"
            size="small"
            sx={{ height: "40px", marginLeft: "10px" }}
            onClick={() => {
              generatePDF();
            }}
          >
            Download PDF
          </Button>
        </div>
      
        <br />
        <div
          style={{ border: "1px solid black", padding: "5px"}}
          ref={printComponentRef}
        >
 
        <br />
        <div style={{padding:"10px"}}>
          <div style={{ textAlign: "center" }}>
            <h4 style={{ fontSize: "21px", fontWeight: "bold" }}>INDEX</h4>
            <br />
            <h6>
              INSPECTION DETAILS OF TESTING OF HOIST, LIFT & LIFTING MACHINERY
            </h6>
          </div>
          <br />
          <div
            id="summaryBorder"
            style={{ textAlign: "left", fontWeight: "bold" }}
          >
            <table>
              <tbody>
                <tr>
                  <td style={{ border: "none", width: "40%" }}>
                    Place of Inspection{" "}
                  </td>
                  <td style={{ border: "none", width: "60%" }}>
                    : M/s. Siemens Ltd , Plot No. E-76, MIDC, Waluj, Aurangabad
                    - 431136
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "none", width: "40%" }}>
                    Date Of Inspection{" "}
                  </td>
                  <td style={{ border: "none", width: "60%" }}>: </td>
                </tr>
                <tr>
                  <td style={{ border: "none", width: "40%" }}>Shop/Plant </td>
                  <td style={{ border: "none", width: "60%" }}>
                    : Chain Pulley Block
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "none", width: "40%" }}>
                    Name Of Competent Person{" "}
                  </td>
                  <td style={{ border: "none", width: "60%" }}>
                    : RAJENDRA PANDE
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "none", width: "40%" }}>
                    Section Rule{" "}
                  </td>
                  <td style={{ border: "none", width: "60%" }}>
                    : Section 28/29 & Rule 62/64 of MFR 1963
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
<br/>
          <Table
            stickyHeader
            aria-label="sticky table"
            size="small"
            id="invoicelist_table"
          >
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {/* {index === 1  ? (
                <b>{`${columns[1].label}  /  Plant`}</b>
              ) : ( */}
                    <b>{column.label}</b>
                    {/* )} */}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {finalData?.map((row, index) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                  {columns.map((column, columnIndex) => {
                    if (columnIndex === 1) {
                      const value1 = row["equipment_name"] || "";
                      const value2 = row[columns[1].id] || "";
                      const mergedValue = `${value1} ,  ${value2}`;
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {mergedValue}
                        </TableCell>
                      );
                    } else {
                      let value;
                      if (
                        column.id === "certificateValidity" ||
                        column.id === "inspectionDate" ||
                        column.id === "hydraulicTestDate" ||
                        column.id === "internalTestDate" ||
                        column.id === "utrasonicTestDate"
                      ) {
                        let newDate = moment(row[column.id]).format(
                          "DD-MM-YYYY"
                        );
                        value = row[column.id] ? newDate : null;
                      } else {
                        value = row[column.id];
                      }
                      if (column.id === "id") {
                        value = page * rowsPerPage + index + 1;
                      }
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    }
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100, { label: "All", value: -1 }]}
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          component="div"
          colSpan={3}
          SelectProps={{
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          }}
          ActionsComponent={TablePaginationActions}
        />
      </TableContainer>
      {downloadPdfloading && (
        <DownloadPdfLoaderModal
          loading={downloadPdfloading}
          name={"Summary Report"}
        />
      )}
    </div>
  );
};

export default SummaryList;
